import { Button, Grid, Typography, TextField, Box, Hidden, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Search as IconSearch, PersonAdd as IconPersonAdd, AddBusiness as IconAddBusiness } from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setResults } from '../../redux/person/personSearchSlice';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";
import * as personaService from "../../services/personaService"
import * as catalogoService from "../../services/catalogoService"

const Index = () => {
const { isReadOnly } = useMantenimiento("persona");
    const filters = useSelector((state) => state.personSearch.filters);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    // Tipo de persona (catalogo 22) para el filtro.
    const [tiposPersona, setTiposPersona] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        fetchResults()
        fetchTiposPersona()
    }, [])

    const fetchTiposPersona = async () => {
        const data = await catalogoService.getCatalogosByPadre(22)
            .catch((err) => { console.log("Err: ", err) });

        setTiposPersona(data || []);
    }

    const fetchResults = async () => {
        setCargando(true);
        const response = await personaService.getsPersonasResumenViewByNumeroDocumentoYNombres(
            filters.numeroDocumento ?? "",
            filters.nombres ?? "",
            filters.empresa ?? "",
            filters.idTipoPersona ?? 0,)
        setResults(response)
        setCargando(false);
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'nombres', headerName: 'Nombres', width: 300, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                // return <Link to={'/person/edit/' + cellValues.row.id + '/0/0'} style={{ color: 'inherit' }}>{cellValues.row.nombres}</Link>;
                const url =
                    cellValues.row.esEmpresa === true
                        ? `/person/editLegal/${cellValues.row.id}`
                        : `/person/edit/${cellValues.row.id}/0/0`;

                return (
                    <Link
                        to={url}
                        style={{ color: 'inherit' }}
                    >
                        {cellValues.row.nombres}
                    </Link>
                );
            }
        },
        { field: 'tipoDocumento', headerName: 'Tipo Doc', width: 100, sortable: false, headerAlign: 'center' },
        { field: 'numeroDocumento', headerName: 'Nro Doc', width: 120, sortable: false, headerAlign: 'center' },
        // { field: 'tipoPersona', headerName: 'Tipo Per', width: 120, sortable: false, headerAlign: 'center' },
        // { field: 'fechaNacimiento', headerName: 'Nacimiento', width: 120, type: 'date'
        //     , valueFormatter: (params) => moment(params).format('D/MM/YYYY')
        //     , sortable: true, headerAlign: 'center', align: 'center' },
        { field: 'celular', headerName: 'Celular', width: 120, sortable: false, headerAlign: 'center' },
        { field: 'email', headerName: 'Email', width: 120, sortable: false, headerAlign: 'center' },
        { field: 'fechaRegistro', headerName: 'Registro', width: 120, type: 'date'
            , valueFormatter: (params) => moment(params).format('D/MM/YYYY')
            , sortable: true, headerAlign: 'center', align: 'center' },
        {
            field: 'empresa',
            headerName: 'Empresa',
            width: 80,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => {
                const val = params.value ?? params.row?.empresa ?? params.row?.esEmpresa;
                return (val === true || val === "True" || val === "true" || val === "S" || val === "s" || val === 1 || val === "1") ? "S" : "N";
            },
            renderCell: (params) => {
                const val = params.value ?? params.row?.empresa ?? params.row?.esEmpresa;
                return (val === true || val === "True" || val === "true" || val === "S" || val === "s" || val === 1 || val === "1") ? "S" : "N";
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Personas
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={7} sm={4}>
                                <TextField
                                    name="numeroDocumento"
                                    label="Numero Documento"
                                    value={filters.numeroDocumento}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "numeroDocumento", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={9} sm={4}>
                                <TextField
                                    name="nombres"
                                    label="Nombres"
                                    value={filters.nombres}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "nombres", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Empresa</InputLabel>
                                    <Select label="Empresa" value={filters.empresa ?? ""}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "empresa", value: event.target.value}));
                                        }}
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        <MenuItem value="S">Sí</MenuItem>
                                        <MenuItem value="N">No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* Tipo de persona (catalogo 22): padre, participante, terapeuta, etc. */}
                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Tipo Persona</InputLabel>
                                    <Select label="Tipo Persona" value={filters.idTipoPersona ?? 0}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idTipoPersona", value: parseInt(event.target.value)}));
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                    >
                                        <MenuItem value={0}>Todos</MenuItem>
                                        {tiposPersona.map((row) => (
                                            <MenuItem key={row.id} value={row.id}>{row.descripcion}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                toolbarButtons={[
                                    {
                                        text: "Particular",
                                        icon: <IconPersonAdd />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/person/edit/0/0/0")
                                    },
                                    {
                                        text: "Empresa",
                                        icon: <IconAddBusiness />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/person/editLegal/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index



